import axios from "axios";
import { UserStateInterface } from "../../../middleware/interfaces/user/user-state-interface";
import { ProjectEditInterface } from "../../../middleware/interfaces/project/project-edit-inteface";

export const ProjectEdit = {
  Edit: async (state: UserStateInterface) => {
    let serverResponse;
    if (state.data) {
      const ProjectEditData: ProjectEditInterface = state.data;
      const url = "./php/project/project-editor-proxy.php";
      await axios
        .post(url, ProjectEditData)
        .then((response) => {
          serverResponse = response.data;
        })
        .catch((error) => {
          serverResponse = {
            status: "error",
            header: "error",
            message: error.message,
          };
        });
    } else {
      serverResponse = {
        status: "error",
        header: "error",
        message: "Something went wrong! Please contact DigitalCharcoal",
      };
    }
    return serverResponse;
  },
};
